import { render, staticRenderFns } from "./rejected-doctors.vue?vue&type=template&id=0c1e90de&"
import script from "./rejected-doctors.vue?vue&type=script&lang=js&"
export * from "./rejected-doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports